module.exports = __webpack_public_path__ + "img/en.e237b39f.png";